import { gql } from '@apollo/client'

export type SaleInputArgs = Object
export type Upload = File

export const SIGN_UP_MUTATION = gql`
  mutation SignUp(
    $email: String!,
    $password: String!
    $companyName: String
    $cocNumber: String
  ) {
    signUp(
      email: $email
      password: $password
      companyName: $companyName
      cocNumber: $cocNumber
    ) {
      token
    }
  }
`

export const LOGIN_MUTATION = gql`
  mutation LogIn($email: String!, $password: String!) {
    logIn(email: $email, password: $password) {
      token
    }
  }
`

export const NEW_INVESTMENT_MUTATION = gql`
  mutation newInvestment(
    $sale_id: ID!
    $amount: Int!
    $currency: String!
    $payment: ID!
    $termsEffectaGmbh: Boolean!
    $termsFinproAG: Boolean!
  ) {
    newInvestment(
      sale_id: $sale_id
      amount: $amount
      currency: $currency
      payment_id: $payment
      termsEffectaGmbh: $termsEffectaGmbh
      termsFinproAG: $termsFinproAG
    ) {
      id
      user_id
      sale_id
      payment_id
      token_id
      status
      amount
      paid
      currency
      revocable
    }
  }
`

export const CONFIRM_INVESTMENT_MUTATION = gql`
  mutation confirmInvestment($id: Float!) {
    confirmInvestment(id: $id) {
      id
    }
  }
`

export const ADD_TO_WHITELIST = gql`
  mutation addToWhitelist($address: String!) {
    addToWhitelist(account: $address) {
      id
      hash
    }
  }
`

export const ADD_USER_DETAILS = gql`
  mutation addUserData(
    $firstName: String!
    $lastName: String!
    $gender: Int!
    $cellphone: String!
    $birthDate: DateTime!
    $birthCity: String!
    $citizenship: String!
    $politicallyExposed: Boolean!
    $taxNumber: String!
    $notUSTax: Boolean!
    $address: String!
    $addressZipcode: String!
    $addressCity: String!
    $addressCountry: String!
    $idType: Int!
    $idDocumentNumber: String!
    $idDocumentCountry: String!
    $passportIssuingAgency: String!
    $experience: [ExperienceLevel!]
    $employment: String!
    $prevEmployment: String!
    $highestEducation: Int!
    $occupationGroup: Int!
    $skipIdNow: Boolean
    $transactionsPerYear: [Int!]
    $volumePerYear: [Int!]
    $monthlySalary: Float
    $availableCash: Float
  ) {
    addUserDetails(
      firstName: $firstName
      lastName: $lastName
      gender: $gender
      cellphone: $cellphone
      birthDate: $birthDate
      birthCity: $birthCity
      citizenship: $citizenship
      politicallyExposed: $politicallyExposed
      taxNumber: $taxNumber
      notUSTax: $notUSTax
      address: $address
      addressZipcode: $addressZipcode
      addressCity: $addressCity
      addressCountry: $addressCountry
      idType: $idType
      idDocumentNumber: $idDocumentNumber
      idDocumentCountry: $idDocumentCountry
      passportIssuingAgency: $passportIssuingAgency
      experience: $experience
      employment: $employment
      prevEmployment: $prevEmployment
      highestEducation: $highestEducation
      occupationGroup: $occupationGroup
      skipIdNow: $skipIdNow
      transactionsPerYear: $transactionsPerYear
      volumePerYear: $volumePerYear
      monthlySalary: $monthlySalary
      availableCash: $availableCash
    ) {
      id
      password
      email
      profile
      firstName
      lastName
      gender
      cellphone
      birthDate
      birthCity
      citizenship
      politicallyExposed
      taxNumber
      notUSTax
      address
      addressZipcode
      addressCity
      addressCountry
      idType
      idDocumentNumber
      idDocumentCountry
      passportIssuingAgency
      experience
      employment
      prevEmployment
      highestEducation
      occupationGroup
      idNowTransactionId
      idNowId
      idNowStatus
      whitelisted
      account
      default_payment
      payment_accounts {
        id
        bank
        name
        IBAN
        BIC
      }
      transactionsPerYear
      volumePerYear
      availableCash
      monthlySalary
    }
  }
`

export const UPDATE_USER_DETAILS = gql`
  mutation updateUserData(
    $cellphone: String!
    $address: String!
    $addressZipcode: String!
    $addressCity: String!
    $addressCountry: String!
    $experience: [ExperienceLevel!]
    $employment: String!
    $prevEmployment: String!
    $highestEducation: Int!
    $occupationGroup: Int!
    $transactionsPerYear: [Int!]
    $volumePerYear: [Int!]
    $availableCash: Float
    $monthlySalary: Float
  ) {
    updateUserDetails(
      cellphone: $cellphone
      address: $address
      addressZipcode: $addressZipcode
      addressCity: $addressCity
      addressCountry: $addressCountry
      experience: $experience
      employment: $employment
      prevEmployment: $prevEmployment
      highestEducation: $highestEducation
      occupationGroup: $occupationGroup
      transactionsPerYear: $transactionsPerYear
      volumePerYear: $volumePerYear
      availableCash: $availableCash
      monthlySalary: $monthlySalary
    ) {
      id
      password
      email
      profile
      firstName
      lastName
      gender
      cellphone
      birthDate
      birthCity
      citizenship
      politicallyExposed
      taxNumber
      notUSTax
      address
      addressZipcode
      addressCity
      addressCountry
      idType
      idDocumentNumber
      idDocumentCountry
      passportIssuingAgency
      experience
      employment
      prevEmployment
      highestEducation
      occupationGroup
      idNowTransactionId
      idNowId
      idNowStatus
      whitelisted
      account
      default_payment
      payment_accounts {
        id
        bank
        name
        IBAN
        BIC
      }
      transactionsPerYear
      volumePerYear
      availableCash
      monthlySalary
    }
  }
`

export const ADMIN_LOGIN_MUTATION = gql`
  mutation adminLogin($username: String!, $password: String!) {
    adminLogin(username: $username, password: $password) {
      token
    }
  }
`

export const APPROVE_INVESTMENT = gql`
  mutation approveInvestment($id: Float!) {
    approveInvestment(id: $id) {
      id
      status
    }
  }
`

export const ACCEPT_INVESTMENT = gql`
  mutation acceptInvestment($id: Float!) {
    acceptInvestment(id: $id) {
      id
      status
    }
  }
`

export const REJECT_INVESTMENT = gql`
  mutation rejectInvestment($id: Float!) {
    rejectInvestment(id: $id) {
      id
      status
    }
  }
`

export const REVOKE_INVESTMENT = gql`
  mutation revokeInvestment($id: ID!) {
    revokeInvestment(id: $id) {
      id
      status
    }
  }
`

export const NEW_TOKEN = gql`
  mutation newToken(
    $name: String!
    $symbol: String!
    $company: String!
    $description: String!
    $value: Int!
    $currency: String!
    $sale: SaleInputArgs!
    $files: Upload
    $location: String
    $interest: Float
    $LTV: Float
    $asset_type: AssetTypes!
  ) {
    newToken(
      name: $name
      symbol: $symbol
      company: $company
      description: $description
      value: $value
      currency: $currency
      sale: $sale
      files: $files
      location: $location
      interest: $interest
      LTV: $LTV
      asset_type: $asset_type
    ) {
      name
      id
    }
  }
`

export const GET_IDNOW_INFO = gql`
  mutation GetIdNowIdent {
    getIdNowIdent {
      idNowId
      idNowStatus
      idNowTransactionId
    }
  }
`

export const ADMIN_UPDATE_USER_DETAILS = gql`
  mutation adminUpdateUser(
    $id: ID!
    $email: String
    $profile: Boolean
    $firstName: String
    $lastName: String
    $gender: Int
    $cellphone: String
    $birthDate: DateTime
    $birthCity: String
    $citizenship: String
    $politicallyExposed: Boolean
    $taxNumber: String
    $notUSTax: Boolean
    $address: String
    $addressZipcode: String
    $addressCity: String
    $addressCountry: String
    $idType: Int!
    $idDocumentNumber: String
    $idDocumentCountry: String
    $passportIssuingAgency: String
    $experience: [ExperienceLevel!]
    $employment: String
    $prevEmployment: String
    $highestEducation: Float
    $occupationGroup: Float
    $idNowTransactionId: String
    $idNowId: String
    $idNowStatus: String
    $whitelisted: Boolean
    $account: String
    $default_payment: ID
    $idNowApproval: Boolean
    $transactionsPerYear: [Int!]
    $volumePerYear: [Int!]
    $availableCash: Float
    $monthlySalary: Float
  ) {
    updateUser(
      id: $id
      cellphone: $cellphone
      email: $email
      profile: $profile
      firstName: $firstName
      lastName: $lastName
      gender: $gender
      birthDate: $birthDate
      birthCity: $birthCity
      citizenship: $citizenship
      politicallyExposed: $politicallyExposed
      taxNumber: $taxNumber
      notUSTax: $notUSTax
      address: $address
      addressZipcode: $addressZipcode
      addressCity: $addressCity
      addressCountry: $addressCountry
      idType: $idType
      idDocumentNumber: $idDocumentNumber
      idDocumentCountry: $idDocumentCountry
      passportIssuingAgency: $passportIssuingAgency
      experience: $experience
      employment: $employment
      prevEmployment: $prevEmployment
      highestEducation: $highestEducation
      occupationGroup: $occupationGroup
      idNowTransactionId: $idNowTransactionId
      idNowId: $idNowId
      idNowStatus: $idNowStatus
      whitelisted: $whitelisted
      account: $account
      default_payment: $default_payment
      idNowApproval: $idNowApproval
      transactionsPerYear: $transactionsPerYear
      volumePerYear: $volumePerYear
      monthlySalary: $monthlySalary
      availableCash: $availableCash
    ) {
      id
      email
      firstName
      lastName
      whitelisted
      addressCountry
      birthDate
      prevEmployment
      employment
      highestEducation
      occupationGroup
      address
      addressCity
      addressZipcode
      cellphone
      idDocumentCountry
      idType
      idDocumentNumber
      idNowStatus
      idNowTransactionId
      birthCity
      citizenship
      gender
    }
  }
`

export const ADD_PAYMENT = gql`
  mutation addPayment(
    $bank: String!
    $IBAN: String!
    $BIC: String!
    $name: String!
    $makeDefault: Boolean
  ) {
    addPayment(
      bank: $bank
      IBAN: $IBAN
      BIC: $BIC
      name: $name
      makeDefault: $makeDefault
    ) {
      id
      bank
      name
      IBAN
      BIC
    }
  }
`

export const REMOVE_PAYMENT = gql`
  mutation removePayment($id: ID!) {
    removePayment(id: $id)
  }
`

export const SELECT_DEFAULT_PAYMENT = gql`
  mutation selectDefaultPayment($id: ID!) {
    selectDefaultPayment(id: $id)
  }
`
